import * as React from "react";
import { forwardRef } from "react";
const WifiHotspotIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M10.939 18.425a1.5 1.5 0 0 1 2.121 0 .75.75 0 0 1 0 1.06l-.53.53a.75.75 0 0 1-1.061 0l-.53-.53a.75.75 0 0 1 0-1.06zm-3.181-3.182a6 6 0 0 1 8.261-.213l.225.213.051.057a.75.75 0 0 1-1.055 1.055l-.058-.051-.167-.16a4.5 4.5 0 0 0-6.196.16.75.75 0 0 1-1.061-1.061zm-3.183-3.182c3.972-3.972 10.336-4.096 14.458-.372l.392.372.052.058a.75.75 0 0 1-1.056 1.055l-.057-.052-.336-.319a9.002 9.002 0 0 0-12.393.319.75.75 0 0 1-1.061-1.06zM1.393 8.879c5.766-5.766 15.059-5.856 20.936-.271l.277.271.052.057a.75.75 0 0 1-1.056 1.056l-.057-.052-.249-.243a13.5 13.5 0 0 0-18.842.243.75.75 0 0 1-1.061-1.061z"
}));
const ForwardRef = forwardRef(WifiHotspotIcon);
export default ForwardRef;